<template>
  <div
    class="v-tooltip"
    @mouseover="show_tooltip = true"
    @mouseout="show_tooltip = false"
  >
    <slot></slot>
    <div v-show="show_tooltip" class="v-tooltip-body">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
  data() {
    return {
      show_tooltip: false,
    };
  },
};
</script>

<style lang="scss">
.v-tooltip{
  position: relative;

  .v-tooltip-body{
    position: absolute;
    left: -56%;
    bottom: 120%;
    z-index: 99999;
    background: #FFFFFF;
    border-radius: 4px;
    padding: 8px 14px;
    color: #1F2937;
    min-width: 8rem;
    box-shadow: 0px 0px 14px rgba(0, 0, 0, 0.15);
    width: 100%;
    text-align: center;
    &::after{
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      background-color: #FFFFFF;
      position: absolute;
      top: calc(100% - 4px);
      left: 25%;
      transform: rotateZ(45deg);
    }
  }
}
</style>